// NAME
const STORE_NAME = "state";

// NETWORK
const NETWORK_CONFIG = {
  HOST: import.meta.env.VITE_APP_URL,
  API_BASE_URL: import.meta.env.VITE_APP_URL,
  API_BASE_URL_NGROK: import.meta.env.VITE_APP_URL_NGROK,
  PRIVY_APP_ID: import.meta.env.VITE_PRIVY_APP_ID,
  PRIVY_APP_SECRET: import.meta.env.VITE_PRIVY_APP_SECRET,
  BASE_URL: import.meta.env.VITE_WEB_URL,
  TIMEOUT: 30000,
  RETRY: false,
  DISPLAY_ERROR: import.meta.env.VITE_DISPLAY_ERROR === "true",
  USE_TOKEN: true,
  WITH_METADATA: false,
};

const DOMAIN = {
  DEV: import.meta.env.VITE_DEV_DOMAIN,
  PROD: import.meta.env.VITE_PROD_DOMAIN,
  LOCAL: "localhost:3000",
};

// PATHNAME
const PATHNAME = {
  HOME: "/",
  VAULT: "/vault",
  LOGIN: "/login",
  USER_PROFILE: "/user-profile",
  NOT_FOUND: "/404",
  LANDING_PAGE: "/landing-page",
  VERIFY: "/verify",
};

// LANGUAGE
const LANGUAGE = {
  DEFAULT: "en",
};

// CONTRACT
// const CONTRACT = {
//   // CONTROLLER
//   ADDRESS: import.meta.env.VITE_CONTROLLER_ADDRESS,
//   FUND_VAULT: import.meta.env.VITE_FUND_VAULT_ADDRESS,
//   CROSS_CHAIN: import.meta.env.VITE_CROSS_CHAIN_ROUTER,
//   REFERRAL: import.meta.env.VITE_REFERRAL_ADDRESS,
//   // TOKENS
//   USDC: import.meta.env.VITE_USDC_ADDRESS,
//   USDT: import.meta.env.VITE_USDT_ADDRESS,
//   USD_MOCK: import.meta.env.VITE_USD_MOCK_ADDRESS,
//   USDT_MOCK: import.meta.env.VITE_USDT_MOCK_LINK_REFERRAL_ADDRESS,
//   // RPC
//   LINK_RPC: import.meta.env.VITE_RPC_KEY_BSC_LINK,
//   TEST_LINK: import.meta.env.VITE_TEST_LINK,
//   TEST_LINK_1: import.meta.env.VITE_TEST_LINK_1,
//   TEST_LINK_2: import.meta.env.VITE_TEST_LINK_2,
//   TEST_LINK_3: import.meta.env.VITE_TEST_LINK_3,
//   TEST_LINK_4: import.meta.env.VITE_TEST_LINK_4,
//   TEST_LINK_5: import.meta.env.VITE_TEST_LINK_5,
//   // POOL
//   ALLBRIDGE: import.meta.env.VITE_STRATEGY_ALLBRIDGE,
//   // VALIDATE
//   MIN_DEPOSIT: import.meta.env.VITE_MIN_DEPOSIT,
// };

// TEST_CONTRACT
const CONTRACT = {
  // CONTROLLER
  ADDRESS: import.meta.env.VITE_CONTROLLER_ADDRESS,
  FUND_VAULT: import.meta.env.VITE_FUND_VAULT_ADDRESS,
  CROSS_CHAIN: import.meta.env.VITE_CROSS_CHAIN_ROUTER,
  REFERRAL: import.meta.env.VITE_REFERRAL_ADDRESS,
  // TOKENS
  USDC: import.meta.env.VITE_USD_MOCK_ADDRESS,
  USDT_MOCK: import.meta.env.VITE_USDT_MOCK_LINK_REFERRAL_ADDRESS,
  // RPC
  TEST_LINK_1: import.meta.env.VITE_TEST_LINK_1,
  TEST_LINK_2: import.meta.env.VITE_TEST_LINK_2,
  TEST_LINK_3: import.meta.env.VITE_TEST_LINK_3,
  TEST_LINK_4: import.meta.env.VITE_TEST_LINK_4,
  TEST_LINK_5: import.meta.env.VITE_TEST_LINK_5,
  TEST_LINK_6: import.meta.env.ALCHEMY_API_KEY,
  // POOL
  ALLBRIDGE: import.meta.env.VITE_STRATEGY_ALLBRIDGE,
  // VALIDATE
  MIN_DEPOSIT: import.meta.env.VITE_MIN_DEPOSIT,
};

// SOCIAL
const SOCIAL = {
  FACEBOOK: import.meta.env.VITE_LINK_FACEBOOK,
  TELEGRAM: import.meta.env.VITE_LINK_TELEGRAM,
  TWITTER: import.meta.env.VITE_LINK_X,
  DISCORD: import.meta.env.VITE_LINK_DISCORD,
};

// SENTRY
const SENTRY = {
  DSN: import.meta.env.SENTRY_DSN,
}

export default {
  STORE_NAME,
  NETWORK_CONFIG,
  DOMAIN,
  PATHNAME,
  LANGUAGE,
  CONTRACT,
  SOCIAL,
  SENTRY
};
